// extracted by mini-css-extract-plugin
export default {"skill":"Skill_skill__6X0XO","text":"Skill_text__aTSOR"};